<template>
  <div>
    <v-row>
      <v-col cols="12" md="3">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9">
        <v-sheet color="white" class="pa-5" rounded>
          <h3>لیست خرید ها</h3>
          <v-data-table
            :items="orders"
            :headers="orderHeaders"
            :items-per-page="15"
            :loading="loading"
            loading-text="در حال بررسی ..."
          >
            <template v-slot:[`item.createDateTime`]="{ item }">
              <persian-date :date="item.createDateTime" />
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <number-component :number="item.amount" unit="ریال"></number-component>
            </template>
            <template v-slot:[`item.totalAmount`]="{ item }">
              <number-component :number="item.totalAmount" unit="ریال"></number-component>
            </template>
            <template v-slot:[`item.verify`]="{ item }">
              <v-alert
                outlined
                dense
                :type="item.verify ? 'success' : 'error'"
                class="small mb-0 pa-1 text-right"
              >
                {{ item.verify ? "موفق" : "ناموفق" }}
              </v-alert>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";

export default {
  name: "my-exams-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      loading: true,
      orders: [],
      orderHeaders: [
        { text: "کتاب", value: "book", align: "center" },
        { text: "پایه", value: "grade", align: "center" },
        { text: "زمان ثبت سفارش", value: "createDateTime", align: "center" },
        { text: "قیمت محصول", value: "amount", align: "center" },
        { text: "قیمت پرداختی", value: "totalAmount", align: "center" },
        { text: "وضعیت", value: "verify", align: "center" }
      ]
    };
  },
  created() {
    this.handleGetOrders();
  },
  methods: {
    handleGetOrders() {
      this.$api.get("orders").then((res) => {
        this.orders = res.data.orders;
        this.loading = false;
      });
    }
  }
};
</script>
